import { render } from "./CRFversionControl.vue?vue&type=template&id=20d844f7&scoped=true"
import script from "./CRFversionControl.js?vue&type=script&lang=js"
export * from "./CRFversionControl.js?vue&type=script&lang=js"

import "./CRFversionControl.vue?vue&type=style&index=0&id=20d844f7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d844f7"]])

export default __exports__